import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaBuilding, FaUsers, FaProjectDiagram, FaTruck, FaArrowRight } from 'react-icons/fa';
import '../../styles/ListPage.css';
import './Settings.css';

const ADMIN_ITEMS = [
  {
    id: 'companies',
    title: 'Companies',
    description: 'Manage company names and GST details used across the workspace.',
    path: '/admin/companies',
    icon: FaBuilding
  },
  {
    id: 'clients',
    title: 'Clients',
    description: 'Manage client names, PAN, and GST details used in billing.',
    path: '/clients',
    icon: FaUsers
  },
  {
    id: 'projects',
    title: 'Projects',
    description: 'Manage projects linked to clients with site address and contact details.',
    path: '/admin/projects',
    icon: FaProjectDiagram
  },
  {
    id: 'vendors',
    title: 'Vendors',
    description: 'Manage vendors, vendor types, and optional project assignments.',
    path: '/admin/vendors',
    icon: FaTruck
  }
];

function Admin() {
  const navigate = useNavigate();

  return (
    <div className="settings-page">
      <div className="list-page-header">
        <div className="list-page-title">
          <h1>Admin</h1>
          <p className="list-page-subtitle">Configure workspace preferences and master data</p>
        </div>
      </div>

      <div className="settings-grid">
        {ADMIN_ITEMS.map((item) => {
          const Icon = item.icon;
          return (
            <button
              key={item.id}
              type="button"
              className="settings-card"
              onClick={() => navigate(item.path)}
            >
              <span className="settings-card-icon" aria-hidden="true">
                <Icon />
              </span>
              <div className="settings-card-body">
                <h2>{item.title}</h2>
                <p>{item.description}</p>
              </div>
              <FaArrowRight className="settings-card-arrow" aria-hidden="true" />
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default Admin;
